// extracted by css-extract-rspack-plugin
export default {"container":"dbNTaRfEHvwYR0bl","iconContainer":"UU2M3ZWw3YocP8wn"};